// src/components/common/NotFound.jsx
import React from 'react';
import { Box, Typography, Button, Container, Paper } from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';
import { Link } from 'react-router-dom';

const NotFound = () => {
    return (
        <Container maxWidth="md">
            <Paper
                elevation={3}
                sx={{
                    mt: 8,
                    p: 4,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center'
                }}
            >
                <WarningIcon
                    sx={{
                        fontSize: 80,
                        color: 'warning.main',
                        mb: 2
                    }}
                />

                <Typography variant="h4" gutterBottom>
                    Page Not Found
                </Typography>

                <Typography variant="body1" color="text.secondary" paragraph>
                    The page you are looking for doesn't exist or has been moved.
                </Typography>

                <Box sx={{ mt: 2 }}>
                    <Button
                        variant="contained"
                        component={Link}
                        to="/dashboard"
                        sx={{ mr: 2 }}
                    >
                        Go to Dashboard
                    </Button>
                    <Button
                        variant="outlined"
                        component={Link}
                        to="/"
                    >
                        Home
                    </Button>
                </Box>
            </Paper>
        </Container>
    );
};

export default NotFound;